import React, { useRef } from 'react'
import chevronDown from "../../assets/img/icons/chevron-down.svg";
import {RefinementListFilter} from "searchkit";

const FilterV2Box = props => {

  const {filteredDataName, translatedTitle, onTransform, listComponent, size, gtmLabel, operator = 'OR', triggerCatalogFilter, sectionType} = props;
  const filterRef = useRef(null)
  const isOpenRef = useRef(null)
  const prevSelectedItemsRef = useRef([])

  const handleClick = () => {
    const filterEl = document.querySelector("#" + filteredDataName + "-filter")
    const containerEl = document.querySelector("#" + filteredDataName + "-filter-container")

    const isCurrentlyOpen = !filterEl.hidden
    const willBeOpen = !isCurrentlyOpen

    isOpenRef.current = willBeOpen

    // toggle visibilidad
    filterEl.hidden = !filterEl.hidden
    containerEl.classList.toggle('filter-active')

    if (willBeOpen && filterRef.current) {
      prevSelectedItemsRef.current = filterRef.current.getSelectedItems() || []
    }
  }

  const handleMouseLeave = () => {
    const filterEl = document.querySelector("#" + filteredDataName + "-filter")
    const containerEl = document.querySelector("#" + filteredDataName + "-filter-container")

    filterEl.hidden = true
    containerEl.classList.remove('filter-active')

    if (isOpenRef.current && (triggerCatalogFilter && typeof triggerCatalogFilter === 'function') && filterRef.current) {
      const selectedItems = filterRef.current.getSelectedItems() || []

      const prevItems = prevSelectedItemsRef.current || []
      const hasChanged = selectedItems.length !== prevItems.length ||
        selectedItems.some(item => !prevItems.includes(item))

      if (hasChanged && selectedItems.length > 0) {
        triggerCatalogFilter(sectionType, filteredDataName, selectedItems)
      }
    }

    isOpenRef.current = false
  }

  return (
    <div className={'filtersV2-box ' + filteredDataName} onMouseLeave={handleMouseLeave} gtm-label={gtmLabel}>
      <div id={filteredDataName + '-filter-container'} className="filter-container">
        <div className="filters-box-items" onClick={handleClick}>
          <span>{translatedTitle}</span>
          <img alt="" src={chevronDown} />
        </div>
        <div hidden={true} id={filteredDataName + '-filter'} className='filter-list'>
          <RefinementListFilter
            ref={filterRef}
            id={filteredDataName}
            field={filteredDataName + ".raw"}
            operator={operator}
            title={translatedTitle}
            bucketsTransform={onTransform}
            size={size}
            listComponent={listComponent}
          />
        </div>
      </div>
    </div>
  )
}

export default FilterV2Box
 